import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export const adminLogin = createServerFn({ method: "POST" })
  .inputValidator((data: { username: string; password: string }) =>
    z.object({ username: z.string().min(1), password: z.string().min(1) }).parse(data),
  )
  .handler(async ({ data }) => {
    const { credentialsMatch, ensureAdminAccount } = await import("./admin-login.server");
    if (!credentialsMatch(data.username, data.password)) {
      return { ok: false as const };
    }
    const credentials = await ensureAdminAccount();
    return { ok: true as const, ...credentials };
  });

/** Directe beheerderstoegang via geheime link, zonder gebruikersnaam of wachtwoord. */
export const adminKeyLogin = createServerFn({ method: "POST" })
  .inputValidator((data: { key: string }) => z.object({ key: z.string().min(1) }).parse(data))
  .handler(async ({ data }) => {
    const { accessKeyMatches, ensureAdminAccount } = await import("./admin-login.server");
    if (!accessKeyMatches(data.key)) {
      return { ok: false as const };
    }
    const credentials = await ensureAdminAccount();
    return { ok: true as const, ...credentials };
  });

